import FormUsersCreation, { FormGuestUsersInvitation } from 'Components/FormUsersCreation';
import Modal from 'Components/Shared/Modal';

type Props = {
  isOpen: boolean;
  onClose(): void;
  organizationCode?: string;
};

const ModalUsersCreation = (props: Props) => {
  const { onClose, organizationCode } = props;

  return (
    <Modal {...props} title="component.modals.createUser.heading" maxWidth="md">
      {organizationCode ? (
        <FormGuestUsersInvitation
          onCancel={onClose}
          organizationCode={organizationCode}
        />
      ) : (
        <FormUsersCreation onCancel={onClose} />
      )}
    </Modal>
  );
};

export default ModalUsersCreation;
